import React, { Fragment } from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_arrayReduce-35053fa6.js';
import { a as isArrayLike, h as getTag, n as baseKeys } from './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import { _ as _isFunction } from './_Map-9acd9da3.js';
import './get-f58f8821.js';
import { a as baseProperty } from './_baseIteratee-651c88ed.js';
import './reduce-359d9da9.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import './head-b3f271d9.js';
import { _ as _map } from './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import { Text } from './Typographies.js';
import './index-f96168ba.js';
import { c as chain } from './chain-d06384bf.js';
import { h as hasUnicode } from './_hasUnicode-6e5e26e7.js';
import { i as _isString } from './isString-30e5fe84.js';

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */


var asciiSize = baseProperty('length');
var _asciiSize = asciiSize;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */

var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */

var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */

var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */

function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;

  while (reUnicode.test(string)) {
    ++result;
  }

  return result;
}

var _unicodeSize = unicodeSize;

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */


function stringSize(string) {
  return hasUnicode(string) ? _unicodeSize(string) : _asciiSize(string);
}

var _stringSize = stringSize;

/** `Object#toString` result references. */


var mapTag = '[object Map]',
    setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */

function size(collection) {
  if (collection == null) {
    return 0;
  }

  if (isArrayLike(collection)) {
    return _isString(collection) ? _stringSize(collection) : collection.length;
  }

  var tag = getTag(collection);

  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }

  return baseKeys(collection).length;
}

var size_1 = size;

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n\n  background-color: ", ";\n  border: ", " solid\n    ", ";\n\n  border-spacing: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledTable = styled.table(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.components.table.colors.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.table.borders.borderWidth;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.table.colors.border;
});

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  padding-bottom: ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledTableCell = styled.td(_templateObject$1(), function (_ref) {
  var theme = _ref.theme;
  return theme.components.table.spaces.cell.padding;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.table.spaces.cell.paddingBottom;
});

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: ", " solid\n    ", ";\n  padding: ", ";\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledTableHeaderCell = styled.th(_templateObject$2(), function (_ref) {
  var theme = _ref.theme;
  return theme.components.table.borders.borderWidth;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.table.colors.border;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.table.spaces.header.padding;
});

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n  th:first-child {\n    padding-left: ", ";\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledTableHeaderLine = styled.tr(_templateObject$3(), function (_ref) {
  var theme = _ref.theme;
  return theme.components.table.spaces.firstChildLeftSpacing;
});

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: ", " solid\n    ", ";\n\n  td:first-child {\n    padding-left: ", ";\n  }\n\n  background-color: ", ";\n\n  ", "\n\n  ", "\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledTableLine = styled.tr(_templateObject$4(), function (_ref) {
  var theme = _ref.theme;
  return theme.components.table.borders.borderWidth;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.table.colors.border;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.table.spaces.firstChildLeftSpacing;
}, function (_ref4) {
  var theme = _ref4.theme,
      odd = _ref4.odd;
  return odd == 1 ? theme.components.table.colors.backgroundOdd : theme.components.table.colors.backgroundEven;
}, function (_ref5) {
  var isHoverable = _ref5.isHoverable,
      theme = _ref5.theme;
  return isHoverable ? "&:hover {\n    background: ".concat(theme.components.table.colors.backgroundHover, ";\n  }") : "";
}, function (_ref6) {
  var onClick = _ref6.onClick;
  return !!onClick ? "cursor: pointer;" : "";
});

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

var isNil_1 = isNil;

var renderText = function renderText(content) {
  if (_isString(content)) {
    return React.createElement(Text, null, content);
  }

  return content;
};

var renderCell = function renderCell(col, element, _ref) {
  var renderCell = _ref.renderCell;
  return React.createElement(Fragment, {
    key: "cell-".concat(col.name)
  }, chain(function (element) {
    return !isNil_1(element);
  }, function () {
    return element && _isFunction(element.render) ? element.render(col, element) : null;
  }, function () {
    return col && _isFunction(col.renderCell) ? col.renderCell(col, element) : null;
  }, function () {
    return renderCell ? renderCell(col, element) : null;
  }, function () {
    return React.createElement(StyledTableCell, null, renderText(element[col.name]));
  }));
};

var renderDetailsLine = function renderDetailsLine(cols, element, id, odd, _ref) {
  var isDetailsLineHoverable = _ref.isDetailsLineHoverable,
      renderDetailsLine = _ref.renderDetailsLine;

  var colCount = size_1(cols);

  var isDetailsHoverable = 'isDetailsLineHoverable' in element ? element.isDetailsLineHoverable : isDetailsLineHoverable;
  var component = chain( // We assume a valid result as soon as we got a non null element
  function (element) {
    return !isNil_1(element);
  }, function () {
    return element && _isFunction(element.renderDetails) ? element.renderDetails(element, odd) : null;
  }, function () {
    return renderDetailsLine ? renderDetailsLine(element, odd) : null;
  });

  if (!component) {
    return null;
  }

  return React.createElement(Fragment, {
    key: "details-".concat(id)
  }, React.createElement(StyledTableLine, {
    isHoverable: isDetailsHoverable,
    odd: odd
  }, React.createElement(StyledTableCell, {
    colSpan: colCount
  }, component)));
};

var renderEmptyTable = function renderEmptyTable(_ref) {
  var renderEmptyTable = _ref.renderEmptyTable;
  return chain(function (element) {
    return !isNil_1(element);
  }, function () {
    return renderEmptyTable ? renderEmptyTable() : null;
  }, function () {
    return React.createElement(StyledTable, null);
  });
};

var renderHeaderCell = function renderHeaderCell(col, _ref) {
  var renderHeaderCell = _ref.renderHeaderCell;
  return React.createElement(Fragment, {
    key: col.name
  }, chain(function (element) {
    return !isNil_1(element);
  }, function () {
    return renderHeaderCell ? renderHeaderCell(col) : null;
  }, function () {
    return col.renderHeaderCell && _isFunction(col.renderHeaderCell) ? col.renderHeaderCell(col) : null;
  }, function () {
    return React.createElement(StyledTableHeaderCell, null, renderText(col.label));
  }));
};

var renderHeaderLine = function renderHeaderLine(content, _ref) {
  var renderHeaderLine = _ref.renderHeaderLine;
  return chain(function (element) {
    return !isNil_1(element);
  }, function () {
    return renderHeaderLine ? renderHeaderLine(content) : null;
  }, function () {
    return React.createElement(StyledTableHeaderLine, null, content);
  });
};

var renderLine = function renderLine(element, content, id, odd, _ref) {
  var isLineHoverable = _ref.isLineHoverable,
      renderLine = _ref.renderLine,
      onLineClick = _ref.onLineClick;
  return React.createElement(Fragment, {
    key: id
  }, chain( // We assume a valid result as soon as we got a non null element
  function (element) {
    return !isNil_1(element);
  }, function () {
    return element && _isFunction(element.render) ? element.render(element, content, odd) : null;
  }, function () {
    return renderLine ? renderLine(element, content, odd) : null;
  }, function () {
    var isHoverable = 'isLineHoverable' in element ? element.isLineHoverable : isLineHoverable;
    var handleLineClick = 'onLineClick' in element ? element.onLineClick : onLineClick;
    return React.createElement(StyledTableLine, {
      onClick: handleLineClick,
      isHoverable: isHoverable,
      odd: odd
    }, content);
  }));
};

var renderTable = function renderTable(content, _ref) {
  var className = _ref.className,
      renderTable = _ref.renderTable;
  return chain(function (element) {
    return !isNil_1(element);
  }, function () {
    return renderTable ? renderTable(content) : null;
  }, function () {
    return React.createElement(StyledTable, {
      className: className
    }, content);
  });
};

function _templateObject$5() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A Table component.
 *
 */

var Table = function Table(_ref) {
  var cols = _ref.cols,
      elements = _ref.elements,
      props = _objectWithoutProperties(_ref, ["cols", "elements"]);

  if (size_1(elements) === 0) {
    return renderEmptyTable(props);
  }

  return renderTable(React.createElement(React.Fragment, null, React.createElement("thead", null, renderHeaderLine(React.createElement(React.Fragment, null, _map(cols, function (col) {
    return renderHeaderCell(col, props);
  })), props)), React.createElement("tbody", null, _map(elements, function (element, index) {
    return React.createElement(React.Fragment, {
      key: "line-".concat(element.name)
    }, renderLine(element, React.createElement(React.Fragment, null, _map(cols, function (col) {
      return renderCell(col, element, props);
    })), index, index % 2, props), renderDetailsLine(cols, element, index, index % 2, props));
  }))), props);
};

Table.defaultProps = {
  isDetailsLineHoverable: false,
  isLineHoverable: false,
  onLineClick: null,
  renderCell: null,
  renderDetailsLine: null,
  renderEmptyTable: null,
  renderLine: null,
  renderHeaderLine: null,
  renderHeaderCell: null,
  renderTable: null
};
Table.propTypes = {
  /**
   * The cols to use as header for the table
   */
  cols: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.any
  })).isRequired,

  /**
   * The actuals elements to display in the table
   */
  elements: PropTypes.arrayOf(PropTypes.any).isRequired,

  /**
   *  Are the detailsLines hoverable
   */
  isDetailsLineHoverable: PropTypes.bool,

  /**
   *  Are the lines hoverable
   */
  isLineHoverable: PropTypes.bool,

  /**
   *  Function called when clicking on a line.
   */
  onLineClick: PropTypes.func,

  /**
   *  Define the component used to render each table cells, accept a children params
   */
  renderCell: PropTypes.func,

  /**
   *  Define the component used to render a detailed line
   */
  renderDetailsLine: PropTypes.func,

  /**
   *  Define the component used to render the table content when the table is empty
   */
  renderEmptyTable: PropTypes.func,

  /**
   *  Define the component used to render each table's headers cells, accept a children params
   */
  renderHeaderCell: PropTypes.func,

  /**
   *  Define the component used to render the table's header line, accept a children params
   */
  renderHeaderLine: PropTypes.func,

  /**
   *  Define the component used to render each table's lines, accept a children params
   */
  renderLine: PropTypes.func,

  /**
   *  Define the component used to render the table element, accept a children params
   */
  renderTable: PropTypes.func
};
Table.StyledTable = StyledTable;
Table.StyledTableCell = StyledTableCell;
Table.StyledTableHeaderCell = StyledTableHeaderCell;
Table.StyledTableHeaderLine = StyledTableHeaderLine;
Table.StyledTableLine = StyledTableLine;
/** @component */

var index = styled(Table)(_templateObject$5());

export default index;
